(function () {
  'use strict';

  // Nav scroll darken — skipped if rilum-scroll.js already handles it
  if (!document.getElementById('rl-video-scroll')) {
    var nav = document.getElementById('rl-nav');
    if (nav) {
      function updateNav() { nav.classList.toggle('s', window.scrollY > 40); }
      window.addEventListener('scroll', updateNav, { passive: true });
      updateNav();
    }
  }

  // Mobile menu toggle
  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('.rl-nav__hamburger');
    var mobileNav = document.getElementById('rl-mobile-nav');
    if (!btn || !mobileNav) return;

    btn.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    });

    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

    // Address form toggles (customers/addresses page)
    document.querySelectorAll('.rl-address__toggle, .rl-address__edit').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var targetId = toggle.getAttribute('aria-controls');
        var target = document.getElementById(targetId);
        if (!target) return;
        var isOpen = !target.hidden;
        target.hidden = isOpen;
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  });
}());
